import * as _ from 'lodash';

export function getObjectDiff(
  previousObj: object,
  currentValue: object,
  compareRef = false
): Array<string> {
  return Object.keys(previousObj).reduce((result, key) => {
    if (!currentValue.hasOwnProperty(key)) {
      result.push(key);
    } else if (_.isEqual(previousObj[key], currentValue[key])) {
      const resultKeyIndex = result.indexOf(key);

      if (compareRef && previousObj[key] !== currentValue[key]) {
        result[resultKeyIndex] = `${key}`;
      } else {
        result.splice(resultKeyIndex, 1);
      }
    }
    return result;
  }, Object.keys(currentValue));
}
